import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge
} from './EstudoServiceProtecaoSugeridaClienteConjuge'

import EstudoFormProtecaoSugerida from './EstudoFormProtecaoSugerida'

const EstudoFormProtecaoSugeridaClienteConjuge = ( { variaveisGlobais, values, handleSubmitAutomatico, estudo, vars, report } ) => {

    processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge(values, handleSubmitAutomatico, estudo, vars.jsonConfiguracao, report)

    return (

        <>
            {dadosCompletosCliente(values) && (
                <EstudoFormProtecaoSugerida
                    variaveisGlobais={variaveisGlobais} 
                    values={values}
                    estudo={estudo}
                    vars={vars}
                    titulo={tituloCliente(values)}
                    idClienteConjuge={HARDCODE.idFamiliarCliente}
                    report={report}
                />
            )}

            {dadosCompletosConjuge(values)
                ?
                    <EstudoFormProtecaoSugerida
                        variaveisGlobais={variaveisGlobais} 
                        values={values}
                        estudo={estudo}
                        vars={vars}
                        titulo={tituloConjuge(values)}
                        idClienteConjuge={HARDCODE.idFamiliarConjuge}
                        report={report}
                    />
                :
                    ''
            }
        </>
    )
}

export default EstudoFormProtecaoSugeridaClienteConjuge